import type { JSX } from 'react'

export const SoundOnIcon = (): JSX.Element => (
  <use href='#soundOnIcon' height='100%' width='100%' />
)
